<div class="modal-header">
  <h4 id="reject-migration-modal" class="modal-title">{{ "Reject" | translate }}</h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="!form.valid"
    (click)="reject()"
    class="btn btn-danger"
    type="button"
  >
    {{ "Reject" | translate }}
  </button>
</div>
